import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const DiscardBannerChangesDialog = (props, ref) => {
  const classes = useStyles();

  const { onSubmit } = props;
  const [group, setGroup] = React.useState();

  React.useImperativeHandle(ref, () => ({
    open: (group) => {
      setGroup(group);
    },
  }));

  const handleClose = () => {
    setGroup();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setGroup();
    onSubmit(group || undefined, true);
  };

  return (
    <Dialog open={group !== undefined} onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Änderungen verwerfen</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Du hast noch ungespeicherte Änderungen. Möchtest du diese
            unwiderruflich verwerfen?
          </DialogContentText>
        </DialogContent>
        <div className={classes.spacer} />
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            Abbrechen
          </Button>
          <Button type="submit" color="primary" variant="contained">
            Änderungen verwerfen
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => ({
  spacer: {
    height: theme.spacing(2),
  },
}));

export default React.forwardRef(DiscardBannerChangesDialog);
